import {PolymerElement, html} from '@polymer/polymer';
import {ScopeBinding} from '../behaviors/keli-binding-behavior.js';

class KeliBrowseFooterCell extends ScopeBinding(PolymerElement) {
  static get template() {
    return html`
<style>
  :host {
    display: table-cell;
    white-space: nowrap;
    vertical-align: middle;
    box-sizing: border-box;
    position: relative;
    padding: 1px 6px 0 6px;
    font-size: 12px;
    text-align: right;
    overflow: hidden;
    font-weight: 700;
    min-height: 18px;
    height: 18px;
    border-right: 1px solid var(--keli-browse-toolbar-border-color);
  }

  :host(.activate-action) {
    cursor: pointer;
  }

  :host(.activate-action) span {
    text-decoration: underline;
  }
</style>

<span>[[aggregateValue]]</span>`;
  }

  static get is() {
    return 'keli-browse-footer-cell';
  }

  static get properties() {
    return {
      aggregateValue: {type: String, scopevar: 'aggvalue'},
      keliScopeVarOptions: {type: Object, value: {confine: true}},
      onActivateEventName: {type: String, observer: 'onActivateEventNameChanged'},
      width: {type: Number, value: 150, observer: 'widthChanged'}
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.handleClick);
  }

  widthChanged(newValue) {
    this.style.width = this.style.maxWidth = this.style.minWidth = newValue + 'px';
  }

  handleClick(event) {
    event.stopPropagation();
    if (this.onActivateEventName) {
      this.dispatchEvent(new CustomEvent(this.onActivateEventName, {bubbles: true, composed: true}));
    }
  }

  onActivateEventNameChanged(newValue) {
    if (newValue) {
      this.classList.add('activate-action');
    } else {
      this.classList.remove('activate-action');
    }
  }
}

customElements.define(KeliBrowseFooterCell.is, KeliBrowseFooterCell);
export {KeliBrowseFooterCell};
